import { Paper } from '@mui/material';
import React from 'react';
import { useRecoilStateLoadable, useRecoilValueLoadable } from 'recoil';
import { currentMetric } from '../../recoil/atoms/currentMetric';
import { metrics } from '../../recoil/selectors/metrics';
import { AgentReportsChart } from '../components/charts/AgentReportsChart';
import { MetricDropdown } from '../components/dropdowns/MetricDropdown';
import { TeamDropdown } from '../components/dropdowns/TeamDropdown';

const excludeMetricKeys = [
  'totalPowerlistDials',
  'tduration',
  'allavgduration2',
];
const excludeGroups = ['Duration'];

/**
 * this is the agent reports in call history tabs
 * @param {object} props
 */

export function AgentReports() {
  const [, setMetric] = useRecoilStateLoadable(metrics);
  const metric = useRecoilValueLoadable(metrics);
  const currentMetricKey = metric.getValue(currentMetric)?.current?.key;

  React.useEffect(() => {
    if (currentMetricKey && excludeMetricKeys.includes(currentMetricKey)) {
      setMetric({
        title: 'All Connections',
        key: 'allconnections',
      });
    }
  }, [currentMetricKey]);

  return (
    <Paper square={true} elevation={0}>
      <TeamDropdown />
      <MetricDropdown
        excludeMetricKeys={excludeMetricKeys}
        excludeGroups={excludeGroups}
      />
      <AgentReportsChart />
    </Paper>
  );
}
